import React from "react";
import PropTypes from "prop-types";
import { API } from "api";
import { UTILS } from "utils";
import { useSelector, useDispatch } from "react-redux";
import { AreasAction } from "redux/actions";
import { LoaderAction } from "redux/actions";
import { errorHandler } from "api/api/errorHandler";
import useGetStoreAddedMappedAreas from "./hooks/useGetStoreAddedMapAreas";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
const DeleteMapAreas = ({ onClose, selectedAreas, setSelectedRowsKeys }) => {
  const dispatch = useDispatch();
  const getStoreMappedAddedAreas = useGetStoreAddedMappedAreas();
  const { isLoading } = useSelector((state) => state.LoaderReducer);

  const deleteSelectedAreas = async () => {
    try {
      dispatch(LoaderAction.setLoading(true));
      const userDetail = UTILS.getCurrentUser();
      let objectArray = [];
      selectedAreas.forEach((area) => {
        objectArray.push(area._id);
      });

      const result = await API.deleteStoreMappedArea({
        brandId: userDetail.brandId,
        storeId: selectedAreas[0].storeId,
        mappedAreaBaseDeliveryMethodIds: objectArray,
      });
      if (result?.success === 1) {
        UTILS.successNotification(result.message);
        dispatch(AreasAction.updateSelectedArea([]));
      } else {
        UTILS.errorNotification(errorHandler(result));
      }
      setSelectedRowsKeys([]);

      await getStoreMappedAddedAreas({
        storeId: selectedAreas[0].storeId,
      });
      onClose();
    } catch (error) {
      UTILS.errorNotification(errorHandler(error));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };
  return (
    <div className="w-full bg-white p-2 sm:p-5">
      <div className="flex flex-col items-center px-8 text-center">
        <div className="mb-6 h-44 w-44 mt-6">
          <AppIcon name="trashRed" size={170} className="h-full w-full" />
        </div>
        <h1 className="text-24px font-semibold text-gray-900">Delete Area</h1>
        <p className=" text-3xl text-gray-500 mb-0">
          {selectedAreas?.length === 1
            ? "Are you sure you want to delete this mapped area"
            : `Are you sure you want to delete ${selectedAreas?.length} mapped areas`}
        </p>
      </div>
      <div className="mx-auto mt-4 flex w-full max-w-[760px] items-center justify-center gap-4">
        <AppButton
          variant="secondary"
          size="lg"
          className=" w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
          onClick={onClose}
          disabled={isLoading}
        >
          No, Keep It
        </AppButton>
        <AppButton
          variant="primary"
          size="lg"
          className="w-1/2 text-4xl"
          onClick={deleteSelectedAreas}
          loading={isLoading}
        >
          Yes, Delete
        </AppButton>
      </div>
    </div>
  );
};

DeleteMapAreas.propTypes = {
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
};
export default DeleteMapAreas;
